// extracted by mini-css-extract-plugin
export default {"adsBannerBg":"AdsBanner_adsBannerBg__kJ5bj"};